import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './YoutubeIcon.module.scss';

const YoutubeIcon: FC<YoutubeIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.youtubeIcon, className]}
      viewBox="0 0 44 44"
      {...rest}
    >
      <circle
        data-name="Ellipse 209"
        cx="22"
        cy="22"
        r="22"
        style={{ fill: '#fff' }}
      />
      <path
        data-name="Tracé 4776"
        d="M255.7 19.9a3.8 3.8 0 0 0-.7-1.7 2.5 2.5 0 0 0-1.7-.7c-2.4-.2-6.1-.2-6.1-.2s-3.6 0-6.1.2a2.5 2.5 0 0 0-1.7.7 3.7 3.7 0 0 0-.7 1.7 26.2 26.2 0 0 0-.2 2.8V24a26.2 26.2 0 0 0 .2 2.8 3.8 3.8 0 0 0 .7 1.7 2.9 2.9 0 0 0 1.9.7l5.9.2s3.6 0 6.1-.2a2.5 2.5 0 0 0 1.7-.7 3.8 3.8 0 0 0 .7-1.7 26.2 26.2 0 0 0 .2-2.8v-1.3a26.2 26.2 0 0 0-.2-2.8m-10.3 5.7v-4.8l4.7 2.4z"
        transform="translate(-225 -1.002)"
        style={{ fill: '#003da5' }}
      />
    </Svg>
  );
};

type YoutubeIconProps = {
  className?: string;
};
export default YoutubeIcon;
